/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginActionRouteImport } from './routes/login-action'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HealthRouteImport } from './routes/health'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth.admin/route'
import { Route as AuthAppRouteRouteImport } from './routes/_auth._app/route'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth.admin/index'
import { Route as AuthAppIndexRouteImport } from './routes/_auth._app/index'
import { Route as AuthAppLabelDesignerRouteImport } from './routes/_auth._app/label-designer'
import { Route as AuthAppRunsRouteRouteImport } from './routes/_auth._app/runs/route'
import { Route as AuthAppReportsRouteRouteImport } from './routes/_auth._app/reports/route'
import { Route as AuthAppAccessionsRouteRouteImport } from './routes/_auth._app/accessions/route'
import { Route as AuthAdminInsightsIndexRouteImport } from './routes/_auth.admin/insights/index'
import { Route as AuthAppRunsIndexRouteImport } from './routes/_auth._app/runs/index'
import { Route as AuthAppBrowseIndexRouteImport } from './routes/_auth._app/browse/index'
import { Route as AuthAppViewsIdRouteImport } from './routes/_auth._app/views/$id'
import { Route as AuthAppInsightsExploreRouteImport } from './routes/_auth._app/insights/explore'
import { Route as AuthAppHelpNotificationsRouteImport } from './routes/_auth._app/help/notifications'
import { Route as AuthAppBoardIdRouteImport } from './routes/_auth._app/board/$id'
import { Route as AuthAppAccessionsNewv2RouteImport } from './routes/_auth._app/accessions/newv2'
import { Route as AuthAppAccessionsNewRouteImport } from './routes/_auth._app/accessions/new'
import { Route as AuthAppSubjectsIdRouteRouteImport } from './routes/_auth._app/subjects.$id/route'
import { Route as AuthAppAccessionsIdRouteRouteImport } from './routes/_auth._app/accessions_.$id/route'
import { Route as AuthAdminProcessesIdIndexRouteImport } from './routes/_auth.admin/processes/$id/index'
import { Route as AuthAppRunsIdIndexRouteImport } from './routes/_auth._app/runs/$id.index'
import { Route as AuthAdminWorkflowsIdEditRouteImport } from './routes/_auth.admin/workflows/$id.edit'
import { Route as AuthAdminUsersIdEditRouteImport } from './routes/_auth.admin/users/$id.edit'
import { Route as AuthAdminTubesIdEditRouteImport } from './routes/_auth.admin/tubes/$id.edit'
import { Route as AuthAdminResultsIdEditRouteImport } from './routes/_auth.admin/results/$id.edit'
import { Route as AuthAdminPrintersIdEditRouteImport } from './routes/_auth.admin/printers/$id.edit'
import { Route as AuthAdminPanelsIdEditRouteImport } from './routes/_auth.admin/panels/$id.edit'
import { Route as AuthAdminMaterialsIdEditRouteImport } from './routes/_auth.admin/materials/$id.edit'
import { Route as AuthAdminInstrumentsIdEditRouteImport } from './routes/_auth.admin/instruments/$id.edit'
import { Route as AuthAdminClientsIdEditRouteImport } from './routes/_auth.admin/clients/$id.edit'
import { Route as AuthAdminBillingMasterInvoicesPreviewRouteImport } from './routes/_auth.admin/billing/master-invoices.preview'
import { Route as AuthAdminBillingMasterInvoicesIdRouteImport } from './routes/_auth.admin/billing/master-invoices.$id'
import { Route as AuthAdminBillingInvoicesIdRouteImport } from './routes/_auth.admin/billing/invoices.$id'
import { Route as AuthAppSubjectsIdSamplesRouteImport } from './routes/_auth._app/subjects.$id/samples'
import { Route as AuthAppSubjectsIdReportRouteImport } from './routes/_auth._app/subjects.$id/report'
import { Route as AuthAppSubjectsIdCreateRouteImport } from './routes/_auth._app/subjects.$id/create'
import { Route as AuthAppSubjectsIdAccessionRouteImport } from './routes/_auth._app/subjects.$id/accession'
import { Route as AuthAppRunsIdWorkspaceRouteImport } from './routes/_auth._app/runs/$id.workspace'
import { Route as AuthAppAccessionsIdRequisitionRouteImport } from './routes/_auth._app/accessions_.$id/requisition'
import { Route as AuthAppAccessionsIdReportRouteImport } from './routes/_auth._app/accessions_.$id/report'
import { Route as AuthAppAccessionsIdModalRouteImport } from './routes/_auth._app/accessions/$id.modal'
import { Route as AuthAdminTestsIdEditIndexRouteImport } from './routes/_auth.admin/tests/$id.edit.index'
import { Route as AuthAdminTubesFieldsIdEditRouteImport } from './routes/_auth.admin/tubes/fields.$id.edit'
import { Route as AuthAdminTubesFieldSetsIdEditRouteImport } from './routes/_auth.admin/tubes/field-sets.$id.edit'
import { Route as AuthAdminProcessesIdVersionsVersionIdRouteImport } from './routes/_auth.admin/processes/$id/versions/$versionId'
import { Route as AuthAdminBillingInvoicesPreviewOrgIdRouteImport } from './routes/_auth.admin/billing/invoices.preview.$orgId'
import { Route as AuthAdminAuthProvidersIdEditRouteImport } from './routes/_auth.admin/auth/providers.$id.edit'
import { Route as AuthAppRunsIdWorklistTestIdRouteImport } from './routes/_auth._app/runs/$id.worklist.$testId'
import { Route as AuthAdminTestsIdEditResultsSpecIdRouteImport } from './routes/_auth.admin/tests/$id.edit.results.$specId'
import { Route as AuthAppRunsIdWorklistTestIdResultsOrderIdRouteImport } from './routes/_auth._app/runs/$id.worklist.$testId.results.$orderId'

const AuthAppBoardRouteLazyRouteImport = createFileRoute('/_auth/_app/board')()
const AuthAdminWorkflowsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/workflows/',
)()
const AuthAdminUsersIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/users/',
)()
const AuthAdminTubesIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/tubes/',
)()
const AuthAdminTestsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/tests/',
)()
const AuthAdminSettingsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/settings/',
)()
const AuthAdminResultsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/results/',
)()
const AuthAdminProcessesIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/processes/',
)()
const AuthAdminPrintersIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/printers/',
)()
const AuthAdminPanelsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/panels/',
)()
const AuthAdminMaterialsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/materials/',
)()
const AuthAdminIntegrationsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/integrations/',
)()
const AuthAdminInstrumentsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/instruments/',
)()
const AuthAdminClientsIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/clients/',
)()
const AuthAdminBillingIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/billing/',
)()
const AuthAdminAuthIndexLazyRouteImport =
  createFileRoute('/_auth/admin/auth/')()
const AuthAdminAuditIndexLazyRouteImport = createFileRoute(
  '/_auth/admin/audit/',
)()
const AuthAppSearchIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/search/',
)()
const AuthAppReportsIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/reports/',
)()
const AuthAppInsightsIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/insights/',
)()
const AuthAppHelpIndexLazyRouteImport = createFileRoute('/_auth/_app/help/')()
const AuthAppCommentsIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/comments/',
)()
const AuthAppAccessionsIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/accessions/',
)()
const AuthAdminWorkflowsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/workflows/new',
)()
const AuthAdminTubesNewLazyRouteImport = createFileRoute(
  '/_auth/admin/tubes/new',
)()
const AuthAdminTestsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/tests/new',
)()
const AuthAdminResultsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/results/new',
)()
const AuthAdminProcessesNewLazyRouteImport = createFileRoute(
  '/_auth/admin/processes/new',
)()
const AuthAdminPrintersNewLazyRouteImport = createFileRoute(
  '/_auth/admin/printers/new',
)()
const AuthAdminPanelsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/panels/new',
)()
const AuthAdminMaterialsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/materials/new',
)()
const AuthAdminIntegrationsItransplantLazyRouteImport = createFileRoute(
  '/_auth/admin/integrations/itransplant',
)()
const AuthAdminInstrumentsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/instruments/new',
)()
const AuthAdminClientsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/clients/new',
)()
const AuthAppAuthProfileLazyRouteImport = createFileRoute(
  '/_auth/_app/auth/profile',
)()
const AuthAppAccessionsIdIndexLazyRouteImport = createFileRoute(
  '/_auth/_app/accessions_/$id/',
)()
const AuthAdminTubesFieldsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/tubes/fields/new',
)()
const AuthAdminTubesFieldSetsNewLazyRouteImport = createFileRoute(
  '/_auth/admin/tubes/field-sets/new',
)()
const AuthAdminAuthProvidersNewLazyRouteImport = createFileRoute(
  '/_auth/admin/auth/providers/new',
)()
const AuthAppSubjectsIdResultsLazyRouteImport = createFileRoute(
  '/_auth/_app/subjects/$id/results',
)()

const LoginActionRoute = LoginActionRouteImport.update({
  id: '/login-action',
  path: '/login-action',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/route.lazy').then((d) => d.Route),
)
const AuthAppRouteRoute = AuthAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/route.lazy').then((d) => d.Route),
)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAppIndexRoute = AuthAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/index.lazy').then((d) => d.Route),
)
const AuthAppBoardRouteLazyRoute = AuthAppBoardRouteLazyRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/board/route.lazy').then((d) => d.Route),
)
const AuthAppLabelDesignerRoute = AuthAppLabelDesignerRouteImport.update({
  id: '/label-designer',
  path: '/label-designer',
  getParentRoute: () => AuthAppRouteRoute,
} as any)
const AuthAppRunsRouteRoute = AuthAppRunsRouteRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/runs/route.lazy').then((d) => d.Route),
)
const AuthAppReportsRouteRoute = AuthAppReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthAppRouteRoute,
} as any)
const AuthAppAccessionsRouteRoute = AuthAppAccessionsRouteRouteImport.update({
  id: '/accessions',
  path: '/accessions',
  getParentRoute: () => AuthAppRouteRoute,
} as any)
const AuthAdminWorkflowsIndexLazyRoute =
  AuthAdminWorkflowsIndexLazyRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/workflows/index.lazy').then((d) => d.Route),
  )
const AuthAdminUsersIndexLazyRoute = AuthAdminUsersIndexLazyRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/users/index.lazy').then((d) => d.Route),
)
const AuthAdminTubesIndexLazyRoute = AuthAdminTubesIndexLazyRouteImport.update({
  id: '/tubes/',
  path: '/tubes/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/tubes/index.lazy').then((d) => d.Route),
)
const AuthAdminTestsIndexLazyRoute = AuthAdminTestsIndexLazyRouteImport.update({
  id: '/tests/',
  path: '/tests/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/tests/index.lazy').then((d) => d.Route),
)
const AuthAdminSettingsIndexLazyRoute =
  AuthAdminSettingsIndexLazyRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/settings/index.lazy').then((d) => d.Route),
  )
const AuthAdminResultsIndexLazyRoute =
  AuthAdminResultsIndexLazyRouteImport.update({
    id: '/results/',
    path: '/results/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/results/index.lazy').then((d) => d.Route),
  )
const AuthAdminProcessesIndexLazyRoute =
  AuthAdminProcessesIndexLazyRouteImport.update({
    id: '/processes/',
    path: '/processes/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/processes/index.lazy').then((d) => d.Route),
  )
const AuthAdminPrintersIndexLazyRoute =
  AuthAdminPrintersIndexLazyRouteImport.update({
    id: '/printers/',
    path: '/printers/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/printers/index.lazy').then((d) => d.Route),
  )
const AuthAdminPanelsIndexLazyRoute =
  AuthAdminPanelsIndexLazyRouteImport.update({
    id: '/panels/',
    path: '/panels/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/panels/index.lazy').then((d) => d.Route),
  )
const AuthAdminMaterialsIndexLazyRoute =
  AuthAdminMaterialsIndexLazyRouteImport.update({
    id: '/materials/',
    path: '/materials/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/materials/index.lazy').then((d) => d.Route),
  )
const AuthAdminIntegrationsIndexLazyRoute =
  AuthAdminIntegrationsIndexLazyRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/integrations/index.lazy').then((d) => d.Route),
  )
const AuthAdminInstrumentsIndexLazyRoute =
  AuthAdminInstrumentsIndexLazyRouteImport.update({
    id: '/instruments/',
    path: '/instruments/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/instruments/index.lazy').then((d) => d.Route),
  )
const AuthAdminClientsIndexLazyRoute =
  AuthAdminClientsIndexLazyRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/clients/index.lazy').then((d) => d.Route),
  )
const AuthAdminBillingIndexLazyRoute =
  AuthAdminBillingIndexLazyRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/billing/index.lazy').then((d) => d.Route),
  )
const AuthAdminAuthIndexLazyRoute = AuthAdminAuthIndexLazyRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/auth/index.lazy').then((d) => d.Route),
)
const AuthAdminAuditIndexLazyRoute = AuthAdminAuditIndexLazyRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/audit/index.lazy').then((d) => d.Route),
)
const AuthAppSearchIndexLazyRoute = AuthAppSearchIndexLazyRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/search/index.lazy').then((d) => d.Route),
)
const AuthAppReportsIndexLazyRoute = AuthAppReportsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppReportsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/reports/index.lazy').then((d) => d.Route),
)
const AuthAppInsightsIndexLazyRoute =
  AuthAppInsightsIndexLazyRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/insights/index.lazy').then((d) => d.Route),
  )
const AuthAppHelpIndexLazyRoute = AuthAppHelpIndexLazyRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/help/index.lazy').then((d) => d.Route),
)
const AuthAppCommentsIndexLazyRoute =
  AuthAppCommentsIndexLazyRouteImport.update({
    id: '/comments/',
    path: '/comments/',
    getParentRoute: () => AuthAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/comments/index.lazy').then((d) => d.Route),
  )
const AuthAppAccessionsIndexLazyRoute =
  AuthAppAccessionsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAccessionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/accessions/index.lazy').then((d) => d.Route),
  )
const AuthAdminInsightsIndexRoute = AuthAdminInsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAppRunsIndexRoute = AuthAppRunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAppRunsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/runs/index.lazy').then((d) => d.Route),
)
const AuthAppBrowseIndexRoute = AuthAppBrowseIndexRouteImport.update({
  id: '/browse/',
  path: '/browse/',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/browse/index.lazy').then((d) => d.Route),
)
const AuthAdminWorkflowsNewLazyRoute =
  AuthAdminWorkflowsNewLazyRouteImport.update({
    id: '/workflows/new',
    path: '/workflows/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/workflows/new.lazy').then((d) => d.Route),
  )
const AuthAdminTubesNewLazyRoute = AuthAdminTubesNewLazyRouteImport.update({
  id: '/tubes/new',
  path: '/tubes/new',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/tubes/new.lazy').then((d) => d.Route),
)
const AuthAdminTestsNewLazyRoute = AuthAdminTestsNewLazyRouteImport.update({
  id: '/tests/new',
  path: '/tests/new',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/tests/new.lazy').then((d) => d.Route),
)
const AuthAdminResultsNewLazyRoute = AuthAdminResultsNewLazyRouteImport.update({
  id: '/results/new',
  path: '/results/new',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/results/new.lazy').then((d) => d.Route),
)
const AuthAdminProcessesNewLazyRoute =
  AuthAdminProcessesNewLazyRouteImport.update({
    id: '/processes/new',
    path: '/processes/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/processes/new.lazy').then((d) => d.Route),
  )
const AuthAdminPrintersNewLazyRoute =
  AuthAdminPrintersNewLazyRouteImport.update({
    id: '/printers/new',
    path: '/printers/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/printers/new.lazy').then((d) => d.Route),
  )
const AuthAdminPanelsNewLazyRoute = AuthAdminPanelsNewLazyRouteImport.update({
  id: '/panels/new',
  path: '/panels/new',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/panels/new.lazy').then((d) => d.Route),
)
const AuthAdminMaterialsNewLazyRoute =
  AuthAdminMaterialsNewLazyRouteImport.update({
    id: '/materials/new',
    path: '/materials/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/materials/new.lazy').then((d) => d.Route),
  )
const AuthAdminIntegrationsItransplantLazyRoute =
  AuthAdminIntegrationsItransplantLazyRouteImport.update({
    id: '/integrations/itransplant',
    path: '/integrations/itransplant',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/integrations/itransplant.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminInstrumentsNewLazyRoute =
  AuthAdminInstrumentsNewLazyRouteImport.update({
    id: '/instruments/new',
    path: '/instruments/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/instruments/new.lazy').then((d) => d.Route),
  )
const AuthAdminClientsNewLazyRoute = AuthAdminClientsNewLazyRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/clients/new.lazy').then((d) => d.Route),
)
const AuthAppAuthProfileLazyRoute = AuthAppAuthProfileLazyRouteImport.update({
  id: '/auth/profile',
  path: '/auth/profile',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/auth/profile.lazy').then((d) => d.Route),
)
const AuthAppViewsIdRoute = AuthAppViewsIdRouteImport.update({
  id: '/views/$id',
  path: '/views/$id',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/views/$id.lazy').then((d) => d.Route),
)
const AuthAppInsightsExploreRoute = AuthAppInsightsExploreRouteImport.update({
  id: '/insights/explore',
  path: '/insights/explore',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/insights/explore.lazy').then((d) => d.Route),
)
const AuthAppHelpNotificationsRoute =
  AuthAppHelpNotificationsRouteImport.update({
    id: '/help/notifications',
    path: '/help/notifications',
    getParentRoute: () => AuthAppRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/help/notifications.lazy').then((d) => d.Route),
  )
const AuthAppBoardIdRoute = AuthAppBoardIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthAppBoardRouteLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/board/$id.lazy').then((d) => d.Route),
)
const AuthAppAccessionsNewv2Route = AuthAppAccessionsNewv2RouteImport.update({
  id: '/newv2',
  path: '/newv2',
  getParentRoute: () => AuthAppAccessionsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/accessions/newv2.lazy').then((d) => d.Route),
)
const AuthAppAccessionsNewRoute = AuthAppAccessionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthAppAccessionsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/accessions/new.lazy').then((d) => d.Route),
)
const AuthAppSubjectsIdRouteRoute = AuthAppSubjectsIdRouteRouteImport.update({
  id: '/subjects/$id',
  path: '/subjects/$id',
  getParentRoute: () => AuthAppRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/subjects.$id/route.lazy').then((d) => d.Route),
)
const AuthAppAccessionsIdRouteRoute =
  AuthAppAccessionsIdRouteRouteImport.update({
    id: '/accessions_/$id',
    path: '/accessions/$id',
    getParentRoute: () => AuthAppRouteRoute,
  } as any)
const AuthAppAccessionsIdIndexLazyRoute =
  AuthAppAccessionsIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAppAccessionsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/accessions_.$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminProcessesIdIndexRoute =
  AuthAdminProcessesIdIndexRouteImport.update({
    id: '/processes/$id/',
    path: '/processes/$id/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/processes/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppRunsIdIndexRoute = AuthAppRunsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AuthAppRunsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/runs/$id.index.lazy').then((d) => d.Route),
)
const AuthAdminTubesFieldsNewLazyRoute =
  AuthAdminTubesFieldsNewLazyRouteImport.update({
    id: '/tubes/fields/new',
    path: '/tubes/fields/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tubes/fields.new.lazy').then((d) => d.Route),
  )
const AuthAdminTubesFieldSetsNewLazyRoute =
  AuthAdminTubesFieldSetsNewLazyRouteImport.update({
    id: '/tubes/field-sets/new',
    path: '/tubes/field-sets/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tubes/field-sets.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminAuthProvidersNewLazyRoute =
  AuthAdminAuthProvidersNewLazyRouteImport.update({
    id: '/auth/providers/new',
    path: '/auth/providers/new',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/auth/providers.new.lazy').then((d) => d.Route),
  )
const AuthAppSubjectsIdResultsLazyRoute =
  AuthAppSubjectsIdResultsLazyRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AuthAppSubjectsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/subjects.$id/results.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminWorkflowsIdEditRoute =
  AuthAdminWorkflowsIdEditRouteImport.update({
    id: '/workflows/$id/edit',
    path: '/workflows/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/workflows/$id.edit.lazy').then((d) => d.Route),
  )
const AuthAdminUsersIdEditRoute = AuthAdminUsersIdEditRouteImport.update({
  id: '/users/$id/edit',
  path: '/users/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/users/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminTubesIdEditRoute = AuthAdminTubesIdEditRouteImport.update({
  id: '/tubes/$id/edit',
  path: '/tubes/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/tubes/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminResultsIdEditRoute = AuthAdminResultsIdEditRouteImport.update({
  id: '/results/$id/edit',
  path: '/results/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/results/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminPrintersIdEditRoute = AuthAdminPrintersIdEditRouteImport.update({
  id: '/printers/$id/edit',
  path: '/printers/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/printers/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminPanelsIdEditRoute = AuthAdminPanelsIdEditRouteImport.update({
  id: '/panels/$id/edit',
  path: '/panels/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/panels/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminMaterialsIdEditRoute =
  AuthAdminMaterialsIdEditRouteImport.update({
    id: '/materials/$id/edit',
    path: '/materials/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/materials/$id.edit.lazy').then((d) => d.Route),
  )
const AuthAdminInstrumentsIdEditRoute =
  AuthAdminInstrumentsIdEditRouteImport.update({
    id: '/instruments/$id/edit',
    path: '/instruments/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/instruments/$id.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminClientsIdEditRoute = AuthAdminClientsIdEditRouteImport.update({
  id: '/clients/$id/edit',
  path: '/clients/$id/edit',
  getParentRoute: () => AuthAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth.admin/clients/$id.edit.lazy').then((d) => d.Route),
)
const AuthAdminBillingMasterInvoicesPreviewRoute =
  AuthAdminBillingMasterInvoicesPreviewRouteImport.update({
    id: '/billing/master-invoices/preview',
    path: '/billing/master-invoices/preview',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/billing/master-invoices.preview.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminBillingMasterInvoicesIdRoute =
  AuthAdminBillingMasterInvoicesIdRouteImport.update({
    id: '/billing/master-invoices/$id',
    path: '/billing/master-invoices/$id',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/billing/master-invoices.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminBillingInvoicesIdRoute =
  AuthAdminBillingInvoicesIdRouteImport.update({
    id: '/billing/invoices/$id',
    path: '/billing/invoices/$id',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/billing/invoices.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppSubjectsIdSamplesRoute =
  AuthAppSubjectsIdSamplesRouteImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => AuthAppSubjectsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/subjects.$id/samples.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppSubjectsIdReportRoute = AuthAppSubjectsIdReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthAppSubjectsIdRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/subjects.$id/report.lazy').then((d) => d.Route),
)
const AuthAppSubjectsIdCreateRoute = AuthAppSubjectsIdCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthAppSubjectsIdRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/subjects.$id/create.lazy').then((d) => d.Route),
)
const AuthAppSubjectsIdAccessionRoute =
  AuthAppSubjectsIdAccessionRouteImport.update({
    id: '/accession',
    path: '/accession',
    getParentRoute: () => AuthAppSubjectsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/subjects.$id/accession.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppRunsIdWorkspaceRoute = AuthAppRunsIdWorkspaceRouteImport.update({
  id: '/$id/workspace',
  path: '/$id/workspace',
  getParentRoute: () => AuthAppRunsRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth._app/runs/$id.workspace.lazy').then((d) => d.Route),
)
const AuthAppAccessionsIdRequisitionRoute =
  AuthAppAccessionsIdRequisitionRouteImport.update({
    id: '/requisition',
    path: '/requisition',
    getParentRoute: () => AuthAppAccessionsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/accessions_.$id/requisition.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppAccessionsIdReportRoute =
  AuthAppAccessionsIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AuthAppAccessionsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/accessions_.$id/report.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppAccessionsIdModalRoute =
  AuthAppAccessionsIdModalRouteImport.update({
    id: '/$id/modal',
    path: '/$id/modal',
    getParentRoute: () => AuthAppAccessionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/accessions/$id.modal.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminTestsIdEditIndexRoute =
  AuthAdminTestsIdEditIndexRouteImport.update({
    id: '/tests/$id/edit/',
    path: '/tests/$id/edit/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tests/$id.edit.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminTubesFieldsIdEditRoute =
  AuthAdminTubesFieldsIdEditRouteImport.update({
    id: '/tubes/fields/$id/edit',
    path: '/tubes/fields/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tubes/fields.$id.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminTubesFieldSetsIdEditRoute =
  AuthAdminTubesFieldSetsIdEditRouteImport.update({
    id: '/tubes/field-sets/$id/edit',
    path: '/tubes/field-sets/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tubes/field-sets.$id.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminProcessesIdVersionsVersionIdRoute =
  AuthAdminProcessesIdVersionsVersionIdRouteImport.update({
    id: '/processes/$id/versions/$versionId',
    path: '/processes/$id/versions/$versionId',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/processes/$id/versions/$versionId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminBillingInvoicesPreviewOrgIdRoute =
  AuthAdminBillingInvoicesPreviewOrgIdRouteImport.update({
    id: '/billing/invoices/preview/$orgId',
    path: '/billing/invoices/preview/$orgId',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/billing/invoices.preview.$orgId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminAuthProvidersIdEditRoute =
  AuthAdminAuthProvidersIdEditRouteImport.update({
    id: '/auth/providers/$id/edit',
    path: '/auth/providers/$id/edit',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/auth/providers.$id.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppRunsIdWorklistTestIdRoute =
  AuthAppRunsIdWorklistTestIdRouteImport.update({
    id: '/$id/worklist/$testId',
    path: '/$id/worklist/$testId',
    getParentRoute: () => AuthAppRunsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/runs/$id.worklist.$testId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminTestsIdEditResultsSpecIdRoute =
  AuthAdminTestsIdEditResultsSpecIdRouteImport.update({
    id: '/tests/$id/edit/results/$specId',
    path: '/tests/$id/edit/results/$specId',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth.admin/tests/$id.edit.results.$specId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAppRunsIdWorklistTestIdResultsOrderIdRoute =
  AuthAppRunsIdWorklistTestIdResultsOrderIdRouteImport.update({
    id: '/results/$orderId',
    path: '/results/$orderId',
    getParentRoute: () => AuthAppRunsIdWorklistTestIdRoute,
  } as any).lazy(() =>
    import('./routes/_auth._app/runs/$id.worklist.$testId.results.$orderId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthAppIndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/error': typeof ErrorRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/login-action': typeof LoginActionRoute
  '/admin': typeof AuthAdminRouteRouteWithChildren
  '/accessions': typeof AuthAppAccessionsRouteRouteWithChildren
  '/reports': typeof AuthAppReportsRouteRouteWithChildren
  '/runs': typeof AuthAppRunsRouteRouteWithChildren
  '/label-designer': typeof AuthAppLabelDesignerRoute
  '/board': typeof AuthAppBoardRouteLazyRouteWithChildren
  '/admin/': typeof AuthAdminIndexRoute
  '/accessions/$id': typeof AuthAppAccessionsIdRouteRouteWithChildren
  '/subjects/$id': typeof AuthAppSubjectsIdRouteRouteWithChildren
  '/accessions/new': typeof AuthAppAccessionsNewRoute
  '/accessions/newv2': typeof AuthAppAccessionsNewv2Route
  '/board/$id': typeof AuthAppBoardIdRoute
  '/help/notifications': typeof AuthAppHelpNotificationsRoute
  '/insights/explore': typeof AuthAppInsightsExploreRoute
  '/views/$id': typeof AuthAppViewsIdRoute
  '/auth/profile': typeof AuthAppAuthProfileLazyRoute
  '/admin/clients/new': typeof AuthAdminClientsNewLazyRoute
  '/admin/instruments/new': typeof AuthAdminInstrumentsNewLazyRoute
  '/admin/integrations/itransplant': typeof AuthAdminIntegrationsItransplantLazyRoute
  '/admin/materials/new': typeof AuthAdminMaterialsNewLazyRoute
  '/admin/panels/new': typeof AuthAdminPanelsNewLazyRoute
  '/admin/printers/new': typeof AuthAdminPrintersNewLazyRoute
  '/admin/processes/new': typeof AuthAdminProcessesNewLazyRoute
  '/admin/results/new': typeof AuthAdminResultsNewLazyRoute
  '/admin/tests/new': typeof AuthAdminTestsNewLazyRoute
  '/admin/tubes/new': typeof AuthAdminTubesNewLazyRoute
  '/admin/workflows/new': typeof AuthAdminWorkflowsNewLazyRoute
  '/browse/': typeof AuthAppBrowseIndexRoute
  '/runs/': typeof AuthAppRunsIndexRoute
  '/admin/insights/': typeof AuthAdminInsightsIndexRoute
  '/accessions/': typeof AuthAppAccessionsIndexLazyRoute
  '/comments/': typeof AuthAppCommentsIndexLazyRoute
  '/help/': typeof AuthAppHelpIndexLazyRoute
  '/insights/': typeof AuthAppInsightsIndexLazyRoute
  '/reports/': typeof AuthAppReportsIndexLazyRoute
  '/search/': typeof AuthAppSearchIndexLazyRoute
  '/admin/audit/': typeof AuthAdminAuditIndexLazyRoute
  '/admin/auth/': typeof AuthAdminAuthIndexLazyRoute
  '/admin/billing/': typeof AuthAdminBillingIndexLazyRoute
  '/admin/clients/': typeof AuthAdminClientsIndexLazyRoute
  '/admin/instruments/': typeof AuthAdminInstrumentsIndexLazyRoute
  '/admin/integrations/': typeof AuthAdminIntegrationsIndexLazyRoute
  '/admin/materials/': typeof AuthAdminMaterialsIndexLazyRoute
  '/admin/panels/': typeof AuthAdminPanelsIndexLazyRoute
  '/admin/printers/': typeof AuthAdminPrintersIndexLazyRoute
  '/admin/processes/': typeof AuthAdminProcessesIndexLazyRoute
  '/admin/results/': typeof AuthAdminResultsIndexLazyRoute
  '/admin/settings/': typeof AuthAdminSettingsIndexLazyRoute
  '/admin/tests/': typeof AuthAdminTestsIndexLazyRoute
  '/admin/tubes/': typeof AuthAdminTubesIndexLazyRoute
  '/admin/users/': typeof AuthAdminUsersIndexLazyRoute
  '/admin/workflows/': typeof AuthAdminWorkflowsIndexLazyRoute
  '/accessions/$id/modal': typeof AuthAppAccessionsIdModalRoute
  '/accessions/$id/report': typeof AuthAppAccessionsIdReportRoute
  '/accessions/$id/requisition': typeof AuthAppAccessionsIdRequisitionRoute
  '/runs/$id/workspace': typeof AuthAppRunsIdWorkspaceRoute
  '/subjects/$id/accession': typeof AuthAppSubjectsIdAccessionRoute
  '/subjects/$id/create': typeof AuthAppSubjectsIdCreateRoute
  '/subjects/$id/report': typeof AuthAppSubjectsIdReportRoute
  '/subjects/$id/samples': typeof AuthAppSubjectsIdSamplesRoute
  '/admin/billing/invoices/$id': typeof AuthAdminBillingInvoicesIdRoute
  '/admin/billing/master-invoices/$id': typeof AuthAdminBillingMasterInvoicesIdRoute
  '/admin/billing/master-invoices/preview': typeof AuthAdminBillingMasterInvoicesPreviewRoute
  '/admin/clients/$id/edit': typeof AuthAdminClientsIdEditRoute
  '/admin/instruments/$id/edit': typeof AuthAdminInstrumentsIdEditRoute
  '/admin/materials/$id/edit': typeof AuthAdminMaterialsIdEditRoute
  '/admin/panels/$id/edit': typeof AuthAdminPanelsIdEditRoute
  '/admin/printers/$id/edit': typeof AuthAdminPrintersIdEditRoute
  '/admin/results/$id/edit': typeof AuthAdminResultsIdEditRoute
  '/admin/tubes/$id/edit': typeof AuthAdminTubesIdEditRoute
  '/admin/users/$id/edit': typeof AuthAdminUsersIdEditRoute
  '/admin/workflows/$id/edit': typeof AuthAdminWorkflowsIdEditRoute
  '/subjects/$id/results': typeof AuthAppSubjectsIdResultsLazyRoute
  '/admin/auth/providers/new': typeof AuthAdminAuthProvidersNewLazyRoute
  '/admin/tubes/field-sets/new': typeof AuthAdminTubesFieldSetsNewLazyRoute
  '/admin/tubes/fields/new': typeof AuthAdminTubesFieldsNewLazyRoute
  '/runs/$id/': typeof AuthAppRunsIdIndexRoute
  '/admin/processes/$id/': typeof AuthAdminProcessesIdIndexRoute
  '/accessions/$id/': typeof AuthAppAccessionsIdIndexLazyRoute
  '/runs/$id/worklist/$testId': typeof AuthAppRunsIdWorklistTestIdRouteWithChildren
  '/admin/auth/providers/$id/edit': typeof AuthAdminAuthProvidersIdEditRoute
  '/admin/billing/invoices/preview/$orgId': typeof AuthAdminBillingInvoicesPreviewOrgIdRoute
  '/admin/processes/$id/versions/$versionId': typeof AuthAdminProcessesIdVersionsVersionIdRoute
  '/admin/tubes/field-sets/$id/edit': typeof AuthAdminTubesFieldSetsIdEditRoute
  '/admin/tubes/fields/$id/edit': typeof AuthAdminTubesFieldsIdEditRoute
  '/admin/tests/$id/edit/': typeof AuthAdminTestsIdEditIndexRoute
  '/admin/tests/$id/edit/results/$specId': typeof AuthAdminTestsIdEditResultsSpecIdRoute
  '/runs/$id/worklist/$testId/results/$orderId': typeof AuthAppRunsIdWorklistTestIdResultsOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthAppIndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/error': typeof ErrorRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/login-action': typeof LoginActionRoute
  '/label-designer': typeof AuthAppLabelDesignerRoute
  '/board': typeof AuthAppBoardRouteLazyRouteWithChildren
  '/admin': typeof AuthAdminIndexRoute
  '/subjects/$id': typeof AuthAppSubjectsIdRouteRouteWithChildren
  '/accessions/new': typeof AuthAppAccessionsNewRoute
  '/accessions/newv2': typeof AuthAppAccessionsNewv2Route
  '/board/$id': typeof AuthAppBoardIdRoute
  '/help/notifications': typeof AuthAppHelpNotificationsRoute
  '/insights/explore': typeof AuthAppInsightsExploreRoute
  '/views/$id': typeof AuthAppViewsIdRoute
  '/auth/profile': typeof AuthAppAuthProfileLazyRoute
  '/admin/clients/new': typeof AuthAdminClientsNewLazyRoute
  '/admin/instruments/new': typeof AuthAdminInstrumentsNewLazyRoute
  '/admin/integrations/itransplant': typeof AuthAdminIntegrationsItransplantLazyRoute
  '/admin/materials/new': typeof AuthAdminMaterialsNewLazyRoute
  '/admin/panels/new': typeof AuthAdminPanelsNewLazyRoute
  '/admin/printers/new': typeof AuthAdminPrintersNewLazyRoute
  '/admin/processes/new': typeof AuthAdminProcessesNewLazyRoute
  '/admin/results/new': typeof AuthAdminResultsNewLazyRoute
  '/admin/tests/new': typeof AuthAdminTestsNewLazyRoute
  '/admin/tubes/new': typeof AuthAdminTubesNewLazyRoute
  '/admin/workflows/new': typeof AuthAdminWorkflowsNewLazyRoute
  '/browse': typeof AuthAppBrowseIndexRoute
  '/runs': typeof AuthAppRunsIndexRoute
  '/admin/insights': typeof AuthAdminInsightsIndexRoute
  '/accessions': typeof AuthAppAccessionsIndexLazyRoute
  '/comments': typeof AuthAppCommentsIndexLazyRoute
  '/help': typeof AuthAppHelpIndexLazyRoute
  '/insights': typeof AuthAppInsightsIndexLazyRoute
  '/reports': typeof AuthAppReportsIndexLazyRoute
  '/search': typeof AuthAppSearchIndexLazyRoute
  '/admin/audit': typeof AuthAdminAuditIndexLazyRoute
  '/admin/auth': typeof AuthAdminAuthIndexLazyRoute
  '/admin/billing': typeof AuthAdminBillingIndexLazyRoute
  '/admin/clients': typeof AuthAdminClientsIndexLazyRoute
  '/admin/instruments': typeof AuthAdminInstrumentsIndexLazyRoute
  '/admin/integrations': typeof AuthAdminIntegrationsIndexLazyRoute
  '/admin/materials': typeof AuthAdminMaterialsIndexLazyRoute
  '/admin/panels': typeof AuthAdminPanelsIndexLazyRoute
  '/admin/printers': typeof AuthAdminPrintersIndexLazyRoute
  '/admin/processes': typeof AuthAdminProcessesIndexLazyRoute
  '/admin/results': typeof AuthAdminResultsIndexLazyRoute
  '/admin/settings': typeof AuthAdminSettingsIndexLazyRoute
  '/admin/tests': typeof AuthAdminTestsIndexLazyRoute
  '/admin/tubes': typeof AuthAdminTubesIndexLazyRoute
  '/admin/users': typeof AuthAdminUsersIndexLazyRoute
  '/admin/workflows': typeof AuthAdminWorkflowsIndexLazyRoute
  '/accessions/$id/modal': typeof AuthAppAccessionsIdModalRoute
  '/accessions/$id/report': typeof AuthAppAccessionsIdReportRoute
  '/accessions/$id/requisition': typeof AuthAppAccessionsIdRequisitionRoute
  '/runs/$id/workspace': typeof AuthAppRunsIdWorkspaceRoute
  '/subjects/$id/accession': typeof AuthAppSubjectsIdAccessionRoute
  '/subjects/$id/create': typeof AuthAppSubjectsIdCreateRoute
  '/subjects/$id/report': typeof AuthAppSubjectsIdReportRoute
  '/subjects/$id/samples': typeof AuthAppSubjectsIdSamplesRoute
  '/admin/billing/invoices/$id': typeof AuthAdminBillingInvoicesIdRoute
  '/admin/billing/master-invoices/$id': typeof AuthAdminBillingMasterInvoicesIdRoute
  '/admin/billing/master-invoices/preview': typeof AuthAdminBillingMasterInvoicesPreviewRoute
  '/admin/clients/$id/edit': typeof AuthAdminClientsIdEditRoute
  '/admin/instruments/$id/edit': typeof AuthAdminInstrumentsIdEditRoute
  '/admin/materials/$id/edit': typeof AuthAdminMaterialsIdEditRoute
  '/admin/panels/$id/edit': typeof AuthAdminPanelsIdEditRoute
  '/admin/printers/$id/edit': typeof AuthAdminPrintersIdEditRoute
  '/admin/results/$id/edit': typeof AuthAdminResultsIdEditRoute
  '/admin/tubes/$id/edit': typeof AuthAdminTubesIdEditRoute
  '/admin/users/$id/edit': typeof AuthAdminUsersIdEditRoute
  '/admin/workflows/$id/edit': typeof AuthAdminWorkflowsIdEditRoute
  '/subjects/$id/results': typeof AuthAppSubjectsIdResultsLazyRoute
  '/admin/auth/providers/new': typeof AuthAdminAuthProvidersNewLazyRoute
  '/admin/tubes/field-sets/new': typeof AuthAdminTubesFieldSetsNewLazyRoute
  '/admin/tubes/fields/new': typeof AuthAdminTubesFieldsNewLazyRoute
  '/runs/$id': typeof AuthAppRunsIdIndexRoute
  '/admin/processes/$id': typeof AuthAdminProcessesIdIndexRoute
  '/accessions/$id': typeof AuthAppAccessionsIdIndexLazyRoute
  '/runs/$id/worklist/$testId': typeof AuthAppRunsIdWorklistTestIdRouteWithChildren
  '/admin/auth/providers/$id/edit': typeof AuthAdminAuthProvidersIdEditRoute
  '/admin/billing/invoices/preview/$orgId': typeof AuthAdminBillingInvoicesPreviewOrgIdRoute
  '/admin/processes/$id/versions/$versionId': typeof AuthAdminProcessesIdVersionsVersionIdRoute
  '/admin/tubes/field-sets/$id/edit': typeof AuthAdminTubesFieldSetsIdEditRoute
  '/admin/tubes/fields/$id/edit': typeof AuthAdminTubesFieldsIdEditRoute
  '/admin/tests/$id/edit': typeof AuthAdminTestsIdEditIndexRoute
  '/admin/tests/$id/edit/results/$specId': typeof AuthAdminTestsIdEditResultsSpecIdRoute
  '/runs/$id/worklist/$testId/results/$orderId': typeof AuthAppRunsIdWorklistTestIdResultsOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/error': typeof ErrorRoute
  '/health': typeof HealthRoute
  '/login': typeof LoginRoute
  '/login-action': typeof LoginActionRoute
  '/_auth/_app': typeof AuthAppRouteRouteWithChildren
  '/_auth/admin': typeof AuthAdminRouteRouteWithChildren
  '/_auth/_app/accessions': typeof AuthAppAccessionsRouteRouteWithChildren
  '/_auth/_app/reports': typeof AuthAppReportsRouteRouteWithChildren
  '/_auth/_app/runs': typeof AuthAppRunsRouteRouteWithChildren
  '/_auth/_app/label-designer': typeof AuthAppLabelDesignerRoute
  '/_auth/_app/board': typeof AuthAppBoardRouteLazyRouteWithChildren
  '/_auth/_app/': typeof AuthAppIndexRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/_app/accessions_/$id': typeof AuthAppAccessionsIdRouteRouteWithChildren
  '/_auth/_app/subjects/$id': typeof AuthAppSubjectsIdRouteRouteWithChildren
  '/_auth/_app/accessions/new': typeof AuthAppAccessionsNewRoute
  '/_auth/_app/accessions/newv2': typeof AuthAppAccessionsNewv2Route
  '/_auth/_app/board/$id': typeof AuthAppBoardIdRoute
  '/_auth/_app/help/notifications': typeof AuthAppHelpNotificationsRoute
  '/_auth/_app/insights/explore': typeof AuthAppInsightsExploreRoute
  '/_auth/_app/views/$id': typeof AuthAppViewsIdRoute
  '/_auth/_app/auth/profile': typeof AuthAppAuthProfileLazyRoute
  '/_auth/admin/clients/new': typeof AuthAdminClientsNewLazyRoute
  '/_auth/admin/instruments/new': typeof AuthAdminInstrumentsNewLazyRoute
  '/_auth/admin/integrations/itransplant': typeof AuthAdminIntegrationsItransplantLazyRoute
  '/_auth/admin/materials/new': typeof AuthAdminMaterialsNewLazyRoute
  '/_auth/admin/panels/new': typeof AuthAdminPanelsNewLazyRoute
  '/_auth/admin/printers/new': typeof AuthAdminPrintersNewLazyRoute
  '/_auth/admin/processes/new': typeof AuthAdminProcessesNewLazyRoute
  '/_auth/admin/results/new': typeof AuthAdminResultsNewLazyRoute
  '/_auth/admin/tests/new': typeof AuthAdminTestsNewLazyRoute
  '/_auth/admin/tubes/new': typeof AuthAdminTubesNewLazyRoute
  '/_auth/admin/workflows/new': typeof AuthAdminWorkflowsNewLazyRoute
  '/_auth/_app/browse/': typeof AuthAppBrowseIndexRoute
  '/_auth/_app/runs/': typeof AuthAppRunsIndexRoute
  '/_auth/admin/insights/': typeof AuthAdminInsightsIndexRoute
  '/_auth/_app/accessions/': typeof AuthAppAccessionsIndexLazyRoute
  '/_auth/_app/comments/': typeof AuthAppCommentsIndexLazyRoute
  '/_auth/_app/help/': typeof AuthAppHelpIndexLazyRoute
  '/_auth/_app/insights/': typeof AuthAppInsightsIndexLazyRoute
  '/_auth/_app/reports/': typeof AuthAppReportsIndexLazyRoute
  '/_auth/_app/search/': typeof AuthAppSearchIndexLazyRoute
  '/_auth/admin/audit/': typeof AuthAdminAuditIndexLazyRoute
  '/_auth/admin/auth/': typeof AuthAdminAuthIndexLazyRoute
  '/_auth/admin/billing/': typeof AuthAdminBillingIndexLazyRoute
  '/_auth/admin/clients/': typeof AuthAdminClientsIndexLazyRoute
  '/_auth/admin/instruments/': typeof AuthAdminInstrumentsIndexLazyRoute
  '/_auth/admin/integrations/': typeof AuthAdminIntegrationsIndexLazyRoute
  '/_auth/admin/materials/': typeof AuthAdminMaterialsIndexLazyRoute
  '/_auth/admin/panels/': typeof AuthAdminPanelsIndexLazyRoute
  '/_auth/admin/printers/': typeof AuthAdminPrintersIndexLazyRoute
  '/_auth/admin/processes/': typeof AuthAdminProcessesIndexLazyRoute
  '/_auth/admin/results/': typeof AuthAdminResultsIndexLazyRoute
  '/_auth/admin/settings/': typeof AuthAdminSettingsIndexLazyRoute
  '/_auth/admin/tests/': typeof AuthAdminTestsIndexLazyRoute
  '/_auth/admin/tubes/': typeof AuthAdminTubesIndexLazyRoute
  '/_auth/admin/users/': typeof AuthAdminUsersIndexLazyRoute
  '/_auth/admin/workflows/': typeof AuthAdminWorkflowsIndexLazyRoute
  '/_auth/_app/accessions/$id/modal': typeof AuthAppAccessionsIdModalRoute
  '/_auth/_app/accessions_/$id/report': typeof AuthAppAccessionsIdReportRoute
  '/_auth/_app/accessions_/$id/requisition': typeof AuthAppAccessionsIdRequisitionRoute
  '/_auth/_app/runs/$id/workspace': typeof AuthAppRunsIdWorkspaceRoute
  '/_auth/_app/subjects/$id/accession': typeof AuthAppSubjectsIdAccessionRoute
  '/_auth/_app/subjects/$id/create': typeof AuthAppSubjectsIdCreateRoute
  '/_auth/_app/subjects/$id/report': typeof AuthAppSubjectsIdReportRoute
  '/_auth/_app/subjects/$id/samples': typeof AuthAppSubjectsIdSamplesRoute
  '/_auth/admin/billing/invoices/$id': typeof AuthAdminBillingInvoicesIdRoute
  '/_auth/admin/billing/master-invoices/$id': typeof AuthAdminBillingMasterInvoicesIdRoute
  '/_auth/admin/billing/master-invoices/preview': typeof AuthAdminBillingMasterInvoicesPreviewRoute
  '/_auth/admin/clients/$id/edit': typeof AuthAdminClientsIdEditRoute
  '/_auth/admin/instruments/$id/edit': typeof AuthAdminInstrumentsIdEditRoute
  '/_auth/admin/materials/$id/edit': typeof AuthAdminMaterialsIdEditRoute
  '/_auth/admin/panels/$id/edit': typeof AuthAdminPanelsIdEditRoute
  '/_auth/admin/printers/$id/edit': typeof AuthAdminPrintersIdEditRoute
  '/_auth/admin/results/$id/edit': typeof AuthAdminResultsIdEditRoute
  '/_auth/admin/tubes/$id/edit': typeof AuthAdminTubesIdEditRoute
  '/_auth/admin/users/$id/edit': typeof AuthAdminUsersIdEditRoute
  '/_auth/admin/workflows/$id/edit': typeof AuthAdminWorkflowsIdEditRoute
  '/_auth/_app/subjects/$id/results': typeof AuthAppSubjectsIdResultsLazyRoute
  '/_auth/admin/auth/providers/new': typeof AuthAdminAuthProvidersNewLazyRoute
  '/_auth/admin/tubes/field-sets/new': typeof AuthAdminTubesFieldSetsNewLazyRoute
  '/_auth/admin/tubes/fields/new': typeof AuthAdminTubesFieldsNewLazyRoute
  '/_auth/_app/runs/$id/': typeof AuthAppRunsIdIndexRoute
  '/_auth/admin/processes/$id/': typeof AuthAdminProcessesIdIndexRoute
  '/_auth/_app/accessions_/$id/': typeof AuthAppAccessionsIdIndexLazyRoute
  '/_auth/_app/runs/$id/worklist/$testId': typeof AuthAppRunsIdWorklistTestIdRouteWithChildren
  '/_auth/admin/auth/providers/$id/edit': typeof AuthAdminAuthProvidersIdEditRoute
  '/_auth/admin/billing/invoices/preview/$orgId': typeof AuthAdminBillingInvoicesPreviewOrgIdRoute
  '/_auth/admin/processes/$id/versions/$versionId': typeof AuthAdminProcessesIdVersionsVersionIdRoute
  '/_auth/admin/tubes/field-sets/$id/edit': typeof AuthAdminTubesFieldSetsIdEditRoute
  '/_auth/admin/tubes/fields/$id/edit': typeof AuthAdminTubesFieldsIdEditRoute
  '/_auth/admin/tests/$id/edit/': typeof AuthAdminTestsIdEditIndexRoute
  '/_auth/admin/tests/$id/edit/results/$specId': typeof AuthAdminTestsIdEditResultsSpecIdRoute
  '/_auth/_app/runs/$id/worklist/$testId/results/$orderId': typeof AuthAppRunsIdWorklistTestIdResultsOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/complete-profile'
    | '/error'
    | '/health'
    | '/login'
    | '/login-action'
    | '/admin'
    | '/accessions'
    | '/reports'
    | '/runs'
    | '/label-designer'
    | '/board'
    | '/admin/'
    | '/accessions/$id'
    | '/subjects/$id'
    | '/accessions/new'
    | '/accessions/newv2'
    | '/board/$id'
    | '/help/notifications'
    | '/insights/explore'
    | '/views/$id'
    | '/auth/profile'
    | '/admin/clients/new'
    | '/admin/instruments/new'
    | '/admin/integrations/itransplant'
    | '/admin/materials/new'
    | '/admin/panels/new'
    | '/admin/printers/new'
    | '/admin/processes/new'
    | '/admin/results/new'
    | '/admin/tests/new'
    | '/admin/tubes/new'
    | '/admin/workflows/new'
    | '/browse/'
    | '/runs/'
    | '/admin/insights/'
    | '/accessions/'
    | '/comments/'
    | '/help/'
    | '/insights/'
    | '/reports/'
    | '/search/'
    | '/admin/audit/'
    | '/admin/auth/'
    | '/admin/billing/'
    | '/admin/clients/'
    | '/admin/instruments/'
    | '/admin/integrations/'
    | '/admin/materials/'
    | '/admin/panels/'
    | '/admin/printers/'
    | '/admin/processes/'
    | '/admin/results/'
    | '/admin/settings/'
    | '/admin/tests/'
    | '/admin/tubes/'
    | '/admin/users/'
    | '/admin/workflows/'
    | '/accessions/$id/modal'
    | '/accessions/$id/report'
    | '/accessions/$id/requisition'
    | '/runs/$id/workspace'
    | '/subjects/$id/accession'
    | '/subjects/$id/create'
    | '/subjects/$id/report'
    | '/subjects/$id/samples'
    | '/admin/billing/invoices/$id'
    | '/admin/billing/master-invoices/$id'
    | '/admin/billing/master-invoices/preview'
    | '/admin/clients/$id/edit'
    | '/admin/instruments/$id/edit'
    | '/admin/materials/$id/edit'
    | '/admin/panels/$id/edit'
    | '/admin/printers/$id/edit'
    | '/admin/results/$id/edit'
    | '/admin/tubes/$id/edit'
    | '/admin/users/$id/edit'
    | '/admin/workflows/$id/edit'
    | '/subjects/$id/results'
    | '/admin/auth/providers/new'
    | '/admin/tubes/field-sets/new'
    | '/admin/tubes/fields/new'
    | '/runs/$id/'
    | '/admin/processes/$id/'
    | '/accessions/$id/'
    | '/runs/$id/worklist/$testId'
    | '/admin/auth/providers/$id/edit'
    | '/admin/billing/invoices/preview/$orgId'
    | '/admin/processes/$id/versions/$versionId'
    | '/admin/tubes/field-sets/$id/edit'
    | '/admin/tubes/fields/$id/edit'
    | '/admin/tests/$id/edit/'
    | '/admin/tests/$id/edit/results/$specId'
    | '/runs/$id/worklist/$testId/results/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/complete-profile'
    | '/error'
    | '/health'
    | '/login'
    | '/login-action'
    | '/label-designer'
    | '/board'
    | '/admin'
    | '/subjects/$id'
    | '/accessions/new'
    | '/accessions/newv2'
    | '/board/$id'
    | '/help/notifications'
    | '/insights/explore'
    | '/views/$id'
    | '/auth/profile'
    | '/admin/clients/new'
    | '/admin/instruments/new'
    | '/admin/integrations/itransplant'
    | '/admin/materials/new'
    | '/admin/panels/new'
    | '/admin/printers/new'
    | '/admin/processes/new'
    | '/admin/results/new'
    | '/admin/tests/new'
    | '/admin/tubes/new'
    | '/admin/workflows/new'
    | '/browse'
    | '/runs'
    | '/admin/insights'
    | '/accessions'
    | '/comments'
    | '/help'
    | '/insights'
    | '/reports'
    | '/search'
    | '/admin/audit'
    | '/admin/auth'
    | '/admin/billing'
    | '/admin/clients'
    | '/admin/instruments'
    | '/admin/integrations'
    | '/admin/materials'
    | '/admin/panels'
    | '/admin/printers'
    | '/admin/processes'
    | '/admin/results'
    | '/admin/settings'
    | '/admin/tests'
    | '/admin/tubes'
    | '/admin/users'
    | '/admin/workflows'
    | '/accessions/$id/modal'
    | '/accessions/$id/report'
    | '/accessions/$id/requisition'
    | '/runs/$id/workspace'
    | '/subjects/$id/accession'
    | '/subjects/$id/create'
    | '/subjects/$id/report'
    | '/subjects/$id/samples'
    | '/admin/billing/invoices/$id'
    | '/admin/billing/master-invoices/$id'
    | '/admin/billing/master-invoices/preview'
    | '/admin/clients/$id/edit'
    | '/admin/instruments/$id/edit'
    | '/admin/materials/$id/edit'
    | '/admin/panels/$id/edit'
    | '/admin/printers/$id/edit'
    | '/admin/results/$id/edit'
    | '/admin/tubes/$id/edit'
    | '/admin/users/$id/edit'
    | '/admin/workflows/$id/edit'
    | '/subjects/$id/results'
    | '/admin/auth/providers/new'
    | '/admin/tubes/field-sets/new'
    | '/admin/tubes/fields/new'
    | '/runs/$id'
    | '/admin/processes/$id'
    | '/accessions/$id'
    | '/runs/$id/worklist/$testId'
    | '/admin/auth/providers/$id/edit'
    | '/admin/billing/invoices/preview/$orgId'
    | '/admin/processes/$id/versions/$versionId'
    | '/admin/tubes/field-sets/$id/edit'
    | '/admin/tubes/fields/$id/edit'
    | '/admin/tests/$id/edit'
    | '/admin/tests/$id/edit/results/$specId'
    | '/runs/$id/worklist/$testId/results/$orderId'
  id:
    | '__root__'
    | '/_auth'
    | '/complete-profile'
    | '/error'
    | '/health'
    | '/login'
    | '/login-action'
    | '/_auth/_app'
    | '/_auth/admin'
    | '/_auth/_app/accessions'
    | '/_auth/_app/reports'
    | '/_auth/_app/runs'
    | '/_auth/_app/label-designer'
    | '/_auth/_app/board'
    | '/_auth/_app/'
    | '/_auth/admin/'
    | '/_auth/_app/accessions_/$id'
    | '/_auth/_app/subjects/$id'
    | '/_auth/_app/accessions/new'
    | '/_auth/_app/accessions/newv2'
    | '/_auth/_app/board/$id'
    | '/_auth/_app/help/notifications'
    | '/_auth/_app/insights/explore'
    | '/_auth/_app/views/$id'
    | '/_auth/_app/auth/profile'
    | '/_auth/admin/clients/new'
    | '/_auth/admin/instruments/new'
    | '/_auth/admin/integrations/itransplant'
    | '/_auth/admin/materials/new'
    | '/_auth/admin/panels/new'
    | '/_auth/admin/printers/new'
    | '/_auth/admin/processes/new'
    | '/_auth/admin/results/new'
    | '/_auth/admin/tests/new'
    | '/_auth/admin/tubes/new'
    | '/_auth/admin/workflows/new'
    | '/_auth/_app/browse/'
    | '/_auth/_app/runs/'
    | '/_auth/admin/insights/'
    | '/_auth/_app/accessions/'
    | '/_auth/_app/comments/'
    | '/_auth/_app/help/'
    | '/_auth/_app/insights/'
    | '/_auth/_app/reports/'
    | '/_auth/_app/search/'
    | '/_auth/admin/audit/'
    | '/_auth/admin/auth/'
    | '/_auth/admin/billing/'
    | '/_auth/admin/clients/'
    | '/_auth/admin/instruments/'
    | '/_auth/admin/integrations/'
    | '/_auth/admin/materials/'
    | '/_auth/admin/panels/'
    | '/_auth/admin/printers/'
    | '/_auth/admin/processes/'
    | '/_auth/admin/results/'
    | '/_auth/admin/settings/'
    | '/_auth/admin/tests/'
    | '/_auth/admin/tubes/'
    | '/_auth/admin/users/'
    | '/_auth/admin/workflows/'
    | '/_auth/_app/accessions/$id/modal'
    | '/_auth/_app/accessions_/$id/report'
    | '/_auth/_app/accessions_/$id/requisition'
    | '/_auth/_app/runs/$id/workspace'
    | '/_auth/_app/subjects/$id/accession'
    | '/_auth/_app/subjects/$id/create'
    | '/_auth/_app/subjects/$id/report'
    | '/_auth/_app/subjects/$id/samples'
    | '/_auth/admin/billing/invoices/$id'
    | '/_auth/admin/billing/master-invoices/$id'
    | '/_auth/admin/billing/master-invoices/preview'
    | '/_auth/admin/clients/$id/edit'
    | '/_auth/admin/instruments/$id/edit'
    | '/_auth/admin/materials/$id/edit'
    | '/_auth/admin/panels/$id/edit'
    | '/_auth/admin/printers/$id/edit'
    | '/_auth/admin/results/$id/edit'
    | '/_auth/admin/tubes/$id/edit'
    | '/_auth/admin/users/$id/edit'
    | '/_auth/admin/workflows/$id/edit'
    | '/_auth/_app/subjects/$id/results'
    | '/_auth/admin/auth/providers/new'
    | '/_auth/admin/tubes/field-sets/new'
    | '/_auth/admin/tubes/fields/new'
    | '/_auth/_app/runs/$id/'
    | '/_auth/admin/processes/$id/'
    | '/_auth/_app/accessions_/$id/'
    | '/_auth/_app/runs/$id/worklist/$testId'
    | '/_auth/admin/auth/providers/$id/edit'
    | '/_auth/admin/billing/invoices/preview/$orgId'
    | '/_auth/admin/processes/$id/versions/$versionId'
    | '/_auth/admin/tubes/field-sets/$id/edit'
    | '/_auth/admin/tubes/fields/$id/edit'
    | '/_auth/admin/tests/$id/edit/'
    | '/_auth/admin/tests/$id/edit/results/$specId'
    | '/_auth/_app/runs/$id/worklist/$testId/results/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  CompleteProfileRoute: typeof CompleteProfileRoute
  ErrorRoute: typeof ErrorRoute
  HealthRoute: typeof HealthRoute
  LoginRoute: typeof LoginRoute
  LoginActionRoute: typeof LoginActionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login-action': {
      id: '/login-action'
      path: '/login-action'
      fullPath: '/login-action'
      preLoaderRoute: typeof LoginActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_app': {
      id: '/_auth/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAppRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/': {
      id: '/_auth/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthAppIndexRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/board': {
      id: '/_auth/_app/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof AuthAppBoardRouteLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/label-designer': {
      id: '/_auth/_app/label-designer'
      path: '/label-designer'
      fullPath: '/label-designer'
      preLoaderRoute: typeof AuthAppLabelDesignerRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/runs': {
      id: '/_auth/_app/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof AuthAppRunsRouteRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/reports': {
      id: '/_auth/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthAppReportsRouteRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/accessions': {
      id: '/_auth/_app/accessions'
      path: '/accessions'
      fullPath: '/accessions'
      preLoaderRoute: typeof AuthAppAccessionsRouteRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/admin/workflows/': {
      id: '/_auth/admin/workflows/'
      path: '/workflows'
      fullPath: '/admin/workflows/'
      preLoaderRoute: typeof AuthAdminWorkflowsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/users/': {
      id: '/_auth/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthAdminUsersIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/': {
      id: '/_auth/admin/tubes/'
      path: '/tubes'
      fullPath: '/admin/tubes/'
      preLoaderRoute: typeof AuthAdminTubesIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tests/': {
      id: '/_auth/admin/tests/'
      path: '/tests'
      fullPath: '/admin/tests/'
      preLoaderRoute: typeof AuthAdminTestsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/settings/': {
      id: '/_auth/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AuthAdminSettingsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/results/': {
      id: '/_auth/admin/results/'
      path: '/results'
      fullPath: '/admin/results/'
      preLoaderRoute: typeof AuthAdminResultsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/processes/': {
      id: '/_auth/admin/processes/'
      path: '/processes'
      fullPath: '/admin/processes/'
      preLoaderRoute: typeof AuthAdminProcessesIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/printers/': {
      id: '/_auth/admin/printers/'
      path: '/printers'
      fullPath: '/admin/printers/'
      preLoaderRoute: typeof AuthAdminPrintersIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/panels/': {
      id: '/_auth/admin/panels/'
      path: '/panels'
      fullPath: '/admin/panels/'
      preLoaderRoute: typeof AuthAdminPanelsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/materials/': {
      id: '/_auth/admin/materials/'
      path: '/materials'
      fullPath: '/admin/materials/'
      preLoaderRoute: typeof AuthAdminMaterialsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/integrations/': {
      id: '/_auth/admin/integrations/'
      path: '/integrations'
      fullPath: '/admin/integrations/'
      preLoaderRoute: typeof AuthAdminIntegrationsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/instruments/': {
      id: '/_auth/admin/instruments/'
      path: '/instruments'
      fullPath: '/admin/instruments/'
      preLoaderRoute: typeof AuthAdminInstrumentsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/clients/': {
      id: '/_auth/admin/clients/'
      path: '/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AuthAdminClientsIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/billing/': {
      id: '/_auth/admin/billing/'
      path: '/billing'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AuthAdminBillingIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/auth/': {
      id: '/_auth/admin/auth/'
      path: '/auth'
      fullPath: '/admin/auth/'
      preLoaderRoute: typeof AuthAdminAuthIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/audit/': {
      id: '/_auth/admin/audit/'
      path: '/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AuthAdminAuditIndexLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/search/': {
      id: '/_auth/_app/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthAppSearchIndexLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/reports/': {
      id: '/_auth/_app/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthAppReportsIndexLazyRouteImport
      parentRoute: typeof AuthAppReportsRouteRoute
    }
    '/_auth/_app/insights/': {
      id: '/_auth/_app/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthAppInsightsIndexLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/help/': {
      id: '/_auth/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AuthAppHelpIndexLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/comments/': {
      id: '/_auth/_app/comments/'
      path: '/comments'
      fullPath: '/comments/'
      preLoaderRoute: typeof AuthAppCommentsIndexLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/accessions/': {
      id: '/_auth/_app/accessions/'
      path: '/'
      fullPath: '/accessions/'
      preLoaderRoute: typeof AuthAppAccessionsIndexLazyRouteImport
      parentRoute: typeof AuthAppAccessionsRouteRoute
    }
    '/_auth/admin/insights/': {
      id: '/_auth/admin/insights/'
      path: '/insights'
      fullPath: '/admin/insights/'
      preLoaderRoute: typeof AuthAdminInsightsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/runs/': {
      id: '/_auth/_app/runs/'
      path: '/'
      fullPath: '/runs/'
      preLoaderRoute: typeof AuthAppRunsIndexRouteImport
      parentRoute: typeof AuthAppRunsRouteRoute
    }
    '/_auth/_app/browse/': {
      id: '/_auth/_app/browse/'
      path: '/browse'
      fullPath: '/browse/'
      preLoaderRoute: typeof AuthAppBrowseIndexRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/admin/workflows/new': {
      id: '/_auth/admin/workflows/new'
      path: '/workflows/new'
      fullPath: '/admin/workflows/new'
      preLoaderRoute: typeof AuthAdminWorkflowsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/new': {
      id: '/_auth/admin/tubes/new'
      path: '/tubes/new'
      fullPath: '/admin/tubes/new'
      preLoaderRoute: typeof AuthAdminTubesNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tests/new': {
      id: '/_auth/admin/tests/new'
      path: '/tests/new'
      fullPath: '/admin/tests/new'
      preLoaderRoute: typeof AuthAdminTestsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/results/new': {
      id: '/_auth/admin/results/new'
      path: '/results/new'
      fullPath: '/admin/results/new'
      preLoaderRoute: typeof AuthAdminResultsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/processes/new': {
      id: '/_auth/admin/processes/new'
      path: '/processes/new'
      fullPath: '/admin/processes/new'
      preLoaderRoute: typeof AuthAdminProcessesNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/printers/new': {
      id: '/_auth/admin/printers/new'
      path: '/printers/new'
      fullPath: '/admin/printers/new'
      preLoaderRoute: typeof AuthAdminPrintersNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/panels/new': {
      id: '/_auth/admin/panels/new'
      path: '/panels/new'
      fullPath: '/admin/panels/new'
      preLoaderRoute: typeof AuthAdminPanelsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/materials/new': {
      id: '/_auth/admin/materials/new'
      path: '/materials/new'
      fullPath: '/admin/materials/new'
      preLoaderRoute: typeof AuthAdminMaterialsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/integrations/itransplant': {
      id: '/_auth/admin/integrations/itransplant'
      path: '/integrations/itransplant'
      fullPath: '/admin/integrations/itransplant'
      preLoaderRoute: typeof AuthAdminIntegrationsItransplantLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/instruments/new': {
      id: '/_auth/admin/instruments/new'
      path: '/instruments/new'
      fullPath: '/admin/instruments/new'
      preLoaderRoute: typeof AuthAdminInstrumentsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/clients/new': {
      id: '/_auth/admin/clients/new'
      path: '/clients/new'
      fullPath: '/admin/clients/new'
      preLoaderRoute: typeof AuthAdminClientsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/auth/profile': {
      id: '/_auth/_app/auth/profile'
      path: '/auth/profile'
      fullPath: '/auth/profile'
      preLoaderRoute: typeof AuthAppAuthProfileLazyRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/views/$id': {
      id: '/_auth/_app/views/$id'
      path: '/views/$id'
      fullPath: '/views/$id'
      preLoaderRoute: typeof AuthAppViewsIdRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/insights/explore': {
      id: '/_auth/_app/insights/explore'
      path: '/insights/explore'
      fullPath: '/insights/explore'
      preLoaderRoute: typeof AuthAppInsightsExploreRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/help/notifications': {
      id: '/_auth/_app/help/notifications'
      path: '/help/notifications'
      fullPath: '/help/notifications'
      preLoaderRoute: typeof AuthAppHelpNotificationsRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/board/$id': {
      id: '/_auth/_app/board/$id'
      path: '/$id'
      fullPath: '/board/$id'
      preLoaderRoute: typeof AuthAppBoardIdRouteImport
      parentRoute: typeof AuthAppBoardRouteLazyRoute
    }
    '/_auth/_app/accessions/newv2': {
      id: '/_auth/_app/accessions/newv2'
      path: '/newv2'
      fullPath: '/accessions/newv2'
      preLoaderRoute: typeof AuthAppAccessionsNewv2RouteImport
      parentRoute: typeof AuthAppAccessionsRouteRoute
    }
    '/_auth/_app/accessions/new': {
      id: '/_auth/_app/accessions/new'
      path: '/new'
      fullPath: '/accessions/new'
      preLoaderRoute: typeof AuthAppAccessionsNewRouteImport
      parentRoute: typeof AuthAppAccessionsRouteRoute
    }
    '/_auth/_app/subjects/$id': {
      id: '/_auth/_app/subjects/$id'
      path: '/subjects/$id'
      fullPath: '/subjects/$id'
      preLoaderRoute: typeof AuthAppSubjectsIdRouteRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/accessions_/$id': {
      id: '/_auth/_app/accessions_/$id'
      path: '/accessions/$id'
      fullPath: '/accessions/$id'
      preLoaderRoute: typeof AuthAppAccessionsIdRouteRouteImport
      parentRoute: typeof AuthAppRouteRoute
    }
    '/_auth/_app/accessions_/$id/': {
      id: '/_auth/_app/accessions_/$id/'
      path: '/'
      fullPath: '/accessions/$id/'
      preLoaderRoute: typeof AuthAppAccessionsIdIndexLazyRouteImport
      parentRoute: typeof AuthAppAccessionsIdRouteRoute
    }
    '/_auth/admin/processes/$id/': {
      id: '/_auth/admin/processes/$id/'
      path: '/processes/$id'
      fullPath: '/admin/processes/$id/'
      preLoaderRoute: typeof AuthAdminProcessesIdIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/runs/$id/': {
      id: '/_auth/_app/runs/$id/'
      path: '/$id'
      fullPath: '/runs/$id/'
      preLoaderRoute: typeof AuthAppRunsIdIndexRouteImport
      parentRoute: typeof AuthAppRunsRouteRoute
    }
    '/_auth/admin/tubes/fields/new': {
      id: '/_auth/admin/tubes/fields/new'
      path: '/tubes/fields/new'
      fullPath: '/admin/tubes/fields/new'
      preLoaderRoute: typeof AuthAdminTubesFieldsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/field-sets/new': {
      id: '/_auth/admin/tubes/field-sets/new'
      path: '/tubes/field-sets/new'
      fullPath: '/admin/tubes/field-sets/new'
      preLoaderRoute: typeof AuthAdminTubesFieldSetsNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/auth/providers/new': {
      id: '/_auth/admin/auth/providers/new'
      path: '/auth/providers/new'
      fullPath: '/admin/auth/providers/new'
      preLoaderRoute: typeof AuthAdminAuthProvidersNewLazyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/subjects/$id/results': {
      id: '/_auth/_app/subjects/$id/results'
      path: '/results'
      fullPath: '/subjects/$id/results'
      preLoaderRoute: typeof AuthAppSubjectsIdResultsLazyRouteImport
      parentRoute: typeof AuthAppSubjectsIdRouteRoute
    }
    '/_auth/admin/workflows/$id/edit': {
      id: '/_auth/admin/workflows/$id/edit'
      path: '/workflows/$id/edit'
      fullPath: '/admin/workflows/$id/edit'
      preLoaderRoute: typeof AuthAdminWorkflowsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/users/$id/edit': {
      id: '/_auth/admin/users/$id/edit'
      path: '/users/$id/edit'
      fullPath: '/admin/users/$id/edit'
      preLoaderRoute: typeof AuthAdminUsersIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/$id/edit': {
      id: '/_auth/admin/tubes/$id/edit'
      path: '/tubes/$id/edit'
      fullPath: '/admin/tubes/$id/edit'
      preLoaderRoute: typeof AuthAdminTubesIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/results/$id/edit': {
      id: '/_auth/admin/results/$id/edit'
      path: '/results/$id/edit'
      fullPath: '/admin/results/$id/edit'
      preLoaderRoute: typeof AuthAdminResultsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/printers/$id/edit': {
      id: '/_auth/admin/printers/$id/edit'
      path: '/printers/$id/edit'
      fullPath: '/admin/printers/$id/edit'
      preLoaderRoute: typeof AuthAdminPrintersIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/panels/$id/edit': {
      id: '/_auth/admin/panels/$id/edit'
      path: '/panels/$id/edit'
      fullPath: '/admin/panels/$id/edit'
      preLoaderRoute: typeof AuthAdminPanelsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/materials/$id/edit': {
      id: '/_auth/admin/materials/$id/edit'
      path: '/materials/$id/edit'
      fullPath: '/admin/materials/$id/edit'
      preLoaderRoute: typeof AuthAdminMaterialsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/instruments/$id/edit': {
      id: '/_auth/admin/instruments/$id/edit'
      path: '/instruments/$id/edit'
      fullPath: '/admin/instruments/$id/edit'
      preLoaderRoute: typeof AuthAdminInstrumentsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/clients/$id/edit': {
      id: '/_auth/admin/clients/$id/edit'
      path: '/clients/$id/edit'
      fullPath: '/admin/clients/$id/edit'
      preLoaderRoute: typeof AuthAdminClientsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/billing/master-invoices/preview': {
      id: '/_auth/admin/billing/master-invoices/preview'
      path: '/billing/master-invoices/preview'
      fullPath: '/admin/billing/master-invoices/preview'
      preLoaderRoute: typeof AuthAdminBillingMasterInvoicesPreviewRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/billing/master-invoices/$id': {
      id: '/_auth/admin/billing/master-invoices/$id'
      path: '/billing/master-invoices/$id'
      fullPath: '/admin/billing/master-invoices/$id'
      preLoaderRoute: typeof AuthAdminBillingMasterInvoicesIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/billing/invoices/$id': {
      id: '/_auth/admin/billing/invoices/$id'
      path: '/billing/invoices/$id'
      fullPath: '/admin/billing/invoices/$id'
      preLoaderRoute: typeof AuthAdminBillingInvoicesIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/subjects/$id/samples': {
      id: '/_auth/_app/subjects/$id/samples'
      path: '/samples'
      fullPath: '/subjects/$id/samples'
      preLoaderRoute: typeof AuthAppSubjectsIdSamplesRouteImport
      parentRoute: typeof AuthAppSubjectsIdRouteRoute
    }
    '/_auth/_app/subjects/$id/report': {
      id: '/_auth/_app/subjects/$id/report'
      path: '/report'
      fullPath: '/subjects/$id/report'
      preLoaderRoute: typeof AuthAppSubjectsIdReportRouteImport
      parentRoute: typeof AuthAppSubjectsIdRouteRoute
    }
    '/_auth/_app/subjects/$id/create': {
      id: '/_auth/_app/subjects/$id/create'
      path: '/create'
      fullPath: '/subjects/$id/create'
      preLoaderRoute: typeof AuthAppSubjectsIdCreateRouteImport
      parentRoute: typeof AuthAppSubjectsIdRouteRoute
    }
    '/_auth/_app/subjects/$id/accession': {
      id: '/_auth/_app/subjects/$id/accession'
      path: '/accession'
      fullPath: '/subjects/$id/accession'
      preLoaderRoute: typeof AuthAppSubjectsIdAccessionRouteImport
      parentRoute: typeof AuthAppSubjectsIdRouteRoute
    }
    '/_auth/_app/runs/$id/workspace': {
      id: '/_auth/_app/runs/$id/workspace'
      path: '/$id/workspace'
      fullPath: '/runs/$id/workspace'
      preLoaderRoute: typeof AuthAppRunsIdWorkspaceRouteImport
      parentRoute: typeof AuthAppRunsRouteRoute
    }
    '/_auth/_app/accessions_/$id/requisition': {
      id: '/_auth/_app/accessions_/$id/requisition'
      path: '/requisition'
      fullPath: '/accessions/$id/requisition'
      preLoaderRoute: typeof AuthAppAccessionsIdRequisitionRouteImport
      parentRoute: typeof AuthAppAccessionsIdRouteRoute
    }
    '/_auth/_app/accessions_/$id/report': {
      id: '/_auth/_app/accessions_/$id/report'
      path: '/report'
      fullPath: '/accessions/$id/report'
      preLoaderRoute: typeof AuthAppAccessionsIdReportRouteImport
      parentRoute: typeof AuthAppAccessionsIdRouteRoute
    }
    '/_auth/_app/accessions/$id/modal': {
      id: '/_auth/_app/accessions/$id/modal'
      path: '/$id/modal'
      fullPath: '/accessions/$id/modal'
      preLoaderRoute: typeof AuthAppAccessionsIdModalRouteImport
      parentRoute: typeof AuthAppAccessionsRouteRoute
    }
    '/_auth/admin/tests/$id/edit/': {
      id: '/_auth/admin/tests/$id/edit/'
      path: '/tests/$id/edit'
      fullPath: '/admin/tests/$id/edit/'
      preLoaderRoute: typeof AuthAdminTestsIdEditIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/fields/$id/edit': {
      id: '/_auth/admin/tubes/fields/$id/edit'
      path: '/tubes/fields/$id/edit'
      fullPath: '/admin/tubes/fields/$id/edit'
      preLoaderRoute: typeof AuthAdminTubesFieldsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/tubes/field-sets/$id/edit': {
      id: '/_auth/admin/tubes/field-sets/$id/edit'
      path: '/tubes/field-sets/$id/edit'
      fullPath: '/admin/tubes/field-sets/$id/edit'
      preLoaderRoute: typeof AuthAdminTubesFieldSetsIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/processes/$id/versions/$versionId': {
      id: '/_auth/admin/processes/$id/versions/$versionId'
      path: '/processes/$id/versions/$versionId'
      fullPath: '/admin/processes/$id/versions/$versionId'
      preLoaderRoute: typeof AuthAdminProcessesIdVersionsVersionIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/billing/invoices/preview/$orgId': {
      id: '/_auth/admin/billing/invoices/preview/$orgId'
      path: '/billing/invoices/preview/$orgId'
      fullPath: '/admin/billing/invoices/preview/$orgId'
      preLoaderRoute: typeof AuthAdminBillingInvoicesPreviewOrgIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/auth/providers/$id/edit': {
      id: '/_auth/admin/auth/providers/$id/edit'
      path: '/auth/providers/$id/edit'
      fullPath: '/admin/auth/providers/$id/edit'
      preLoaderRoute: typeof AuthAdminAuthProvidersIdEditRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/runs/$id/worklist/$testId': {
      id: '/_auth/_app/runs/$id/worklist/$testId'
      path: '/$id/worklist/$testId'
      fullPath: '/runs/$id/worklist/$testId'
      preLoaderRoute: typeof AuthAppRunsIdWorklistTestIdRouteImport
      parentRoute: typeof AuthAppRunsRouteRoute
    }
    '/_auth/admin/tests/$id/edit/results/$specId': {
      id: '/_auth/admin/tests/$id/edit/results/$specId'
      path: '/tests/$id/edit/results/$specId'
      fullPath: '/admin/tests/$id/edit/results/$specId'
      preLoaderRoute: typeof AuthAdminTestsIdEditResultsSpecIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_app/runs/$id/worklist/$testId/results/$orderId': {
      id: '/_auth/_app/runs/$id/worklist/$testId/results/$orderId'
      path: '/results/$orderId'
      fullPath: '/runs/$id/worklist/$testId/results/$orderId'
      preLoaderRoute: typeof AuthAppRunsIdWorklistTestIdResultsOrderIdRouteImport
      parentRoute: typeof AuthAppRunsIdWorklistTestIdRoute
    }
  }
}

interface AuthAppAccessionsRouteRouteChildren {
  AuthAppAccessionsNewRoute: typeof AuthAppAccessionsNewRoute
  AuthAppAccessionsNewv2Route: typeof AuthAppAccessionsNewv2Route
  AuthAppAccessionsIndexLazyRoute: typeof AuthAppAccessionsIndexLazyRoute
  AuthAppAccessionsIdModalRoute: typeof AuthAppAccessionsIdModalRoute
}

const AuthAppAccessionsRouteRouteChildren: AuthAppAccessionsRouteRouteChildren =
  {
    AuthAppAccessionsNewRoute: AuthAppAccessionsNewRoute,
    AuthAppAccessionsNewv2Route: AuthAppAccessionsNewv2Route,
    AuthAppAccessionsIndexLazyRoute: AuthAppAccessionsIndexLazyRoute,
    AuthAppAccessionsIdModalRoute: AuthAppAccessionsIdModalRoute,
  }

const AuthAppAccessionsRouteRouteWithChildren =
  AuthAppAccessionsRouteRoute._addFileChildren(
    AuthAppAccessionsRouteRouteChildren,
  )

interface AuthAppReportsRouteRouteChildren {
  AuthAppReportsIndexLazyRoute: typeof AuthAppReportsIndexLazyRoute
}

const AuthAppReportsRouteRouteChildren: AuthAppReportsRouteRouteChildren = {
  AuthAppReportsIndexLazyRoute: AuthAppReportsIndexLazyRoute,
}

const AuthAppReportsRouteRouteWithChildren =
  AuthAppReportsRouteRoute._addFileChildren(AuthAppReportsRouteRouteChildren)

interface AuthAppRunsIdWorklistTestIdRouteChildren {
  AuthAppRunsIdWorklistTestIdResultsOrderIdRoute: typeof AuthAppRunsIdWorklistTestIdResultsOrderIdRoute
}

const AuthAppRunsIdWorklistTestIdRouteChildren: AuthAppRunsIdWorklistTestIdRouteChildren =
  {
    AuthAppRunsIdWorklistTestIdResultsOrderIdRoute:
      AuthAppRunsIdWorklistTestIdResultsOrderIdRoute,
  }

const AuthAppRunsIdWorklistTestIdRouteWithChildren =
  AuthAppRunsIdWorklistTestIdRoute._addFileChildren(
    AuthAppRunsIdWorklistTestIdRouteChildren,
  )

interface AuthAppRunsRouteRouteChildren {
  AuthAppRunsIndexRoute: typeof AuthAppRunsIndexRoute
  AuthAppRunsIdWorkspaceRoute: typeof AuthAppRunsIdWorkspaceRoute
  AuthAppRunsIdIndexRoute: typeof AuthAppRunsIdIndexRoute
  AuthAppRunsIdWorklistTestIdRoute: typeof AuthAppRunsIdWorklistTestIdRouteWithChildren
}

const AuthAppRunsRouteRouteChildren: AuthAppRunsRouteRouteChildren = {
  AuthAppRunsIndexRoute: AuthAppRunsIndexRoute,
  AuthAppRunsIdWorkspaceRoute: AuthAppRunsIdWorkspaceRoute,
  AuthAppRunsIdIndexRoute: AuthAppRunsIdIndexRoute,
  AuthAppRunsIdWorklistTestIdRoute:
    AuthAppRunsIdWorklistTestIdRouteWithChildren,
}

const AuthAppRunsRouteRouteWithChildren =
  AuthAppRunsRouteRoute._addFileChildren(AuthAppRunsRouteRouteChildren)

interface AuthAppBoardRouteLazyRouteChildren {
  AuthAppBoardIdRoute: typeof AuthAppBoardIdRoute
}

const AuthAppBoardRouteLazyRouteChildren: AuthAppBoardRouteLazyRouteChildren = {
  AuthAppBoardIdRoute: AuthAppBoardIdRoute,
}

const AuthAppBoardRouteLazyRouteWithChildren =
  AuthAppBoardRouteLazyRoute._addFileChildren(
    AuthAppBoardRouteLazyRouteChildren,
  )

interface AuthAppAccessionsIdRouteRouteChildren {
  AuthAppAccessionsIdReportRoute: typeof AuthAppAccessionsIdReportRoute
  AuthAppAccessionsIdRequisitionRoute: typeof AuthAppAccessionsIdRequisitionRoute
  AuthAppAccessionsIdIndexLazyRoute: typeof AuthAppAccessionsIdIndexLazyRoute
}

const AuthAppAccessionsIdRouteRouteChildren: AuthAppAccessionsIdRouteRouteChildren =
  {
    AuthAppAccessionsIdReportRoute: AuthAppAccessionsIdReportRoute,
    AuthAppAccessionsIdRequisitionRoute: AuthAppAccessionsIdRequisitionRoute,
    AuthAppAccessionsIdIndexLazyRoute: AuthAppAccessionsIdIndexLazyRoute,
  }

const AuthAppAccessionsIdRouteRouteWithChildren =
  AuthAppAccessionsIdRouteRoute._addFileChildren(
    AuthAppAccessionsIdRouteRouteChildren,
  )

interface AuthAppSubjectsIdRouteRouteChildren {
  AuthAppSubjectsIdAccessionRoute: typeof AuthAppSubjectsIdAccessionRoute
  AuthAppSubjectsIdCreateRoute: typeof AuthAppSubjectsIdCreateRoute
  AuthAppSubjectsIdReportRoute: typeof AuthAppSubjectsIdReportRoute
  AuthAppSubjectsIdSamplesRoute: typeof AuthAppSubjectsIdSamplesRoute
  AuthAppSubjectsIdResultsLazyRoute: typeof AuthAppSubjectsIdResultsLazyRoute
}

const AuthAppSubjectsIdRouteRouteChildren: AuthAppSubjectsIdRouteRouteChildren =
  {
    AuthAppSubjectsIdAccessionRoute: AuthAppSubjectsIdAccessionRoute,
    AuthAppSubjectsIdCreateRoute: AuthAppSubjectsIdCreateRoute,
    AuthAppSubjectsIdReportRoute: AuthAppSubjectsIdReportRoute,
    AuthAppSubjectsIdSamplesRoute: AuthAppSubjectsIdSamplesRoute,
    AuthAppSubjectsIdResultsLazyRoute: AuthAppSubjectsIdResultsLazyRoute,
  }

const AuthAppSubjectsIdRouteRouteWithChildren =
  AuthAppSubjectsIdRouteRoute._addFileChildren(
    AuthAppSubjectsIdRouteRouteChildren,
  )

interface AuthAppRouteRouteChildren {
  AuthAppAccessionsRouteRoute: typeof AuthAppAccessionsRouteRouteWithChildren
  AuthAppReportsRouteRoute: typeof AuthAppReportsRouteRouteWithChildren
  AuthAppRunsRouteRoute: typeof AuthAppRunsRouteRouteWithChildren
  AuthAppLabelDesignerRoute: typeof AuthAppLabelDesignerRoute
  AuthAppBoardRouteLazyRoute: typeof AuthAppBoardRouteLazyRouteWithChildren
  AuthAppIndexRoute: typeof AuthAppIndexRoute
  AuthAppAccessionsIdRouteRoute: typeof AuthAppAccessionsIdRouteRouteWithChildren
  AuthAppSubjectsIdRouteRoute: typeof AuthAppSubjectsIdRouteRouteWithChildren
  AuthAppHelpNotificationsRoute: typeof AuthAppHelpNotificationsRoute
  AuthAppInsightsExploreRoute: typeof AuthAppInsightsExploreRoute
  AuthAppViewsIdRoute: typeof AuthAppViewsIdRoute
  AuthAppAuthProfileLazyRoute: typeof AuthAppAuthProfileLazyRoute
  AuthAppBrowseIndexRoute: typeof AuthAppBrowseIndexRoute
  AuthAppCommentsIndexLazyRoute: typeof AuthAppCommentsIndexLazyRoute
  AuthAppHelpIndexLazyRoute: typeof AuthAppHelpIndexLazyRoute
  AuthAppInsightsIndexLazyRoute: typeof AuthAppInsightsIndexLazyRoute
  AuthAppSearchIndexLazyRoute: typeof AuthAppSearchIndexLazyRoute
}

const AuthAppRouteRouteChildren: AuthAppRouteRouteChildren = {
  AuthAppAccessionsRouteRoute: AuthAppAccessionsRouteRouteWithChildren,
  AuthAppReportsRouteRoute: AuthAppReportsRouteRouteWithChildren,
  AuthAppRunsRouteRoute: AuthAppRunsRouteRouteWithChildren,
  AuthAppLabelDesignerRoute: AuthAppLabelDesignerRoute,
  AuthAppBoardRouteLazyRoute: AuthAppBoardRouteLazyRouteWithChildren,
  AuthAppIndexRoute: AuthAppIndexRoute,
  AuthAppAccessionsIdRouteRoute: AuthAppAccessionsIdRouteRouteWithChildren,
  AuthAppSubjectsIdRouteRoute: AuthAppSubjectsIdRouteRouteWithChildren,
  AuthAppHelpNotificationsRoute: AuthAppHelpNotificationsRoute,
  AuthAppInsightsExploreRoute: AuthAppInsightsExploreRoute,
  AuthAppViewsIdRoute: AuthAppViewsIdRoute,
  AuthAppAuthProfileLazyRoute: AuthAppAuthProfileLazyRoute,
  AuthAppBrowseIndexRoute: AuthAppBrowseIndexRoute,
  AuthAppCommentsIndexLazyRoute: AuthAppCommentsIndexLazyRoute,
  AuthAppHelpIndexLazyRoute: AuthAppHelpIndexLazyRoute,
  AuthAppInsightsIndexLazyRoute: AuthAppInsightsIndexLazyRoute,
  AuthAppSearchIndexLazyRoute: AuthAppSearchIndexLazyRoute,
}

const AuthAppRouteRouteWithChildren = AuthAppRouteRoute._addFileChildren(
  AuthAppRouteRouteChildren,
)

interface AuthAdminRouteRouteChildren {
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminClientsNewLazyRoute: typeof AuthAdminClientsNewLazyRoute
  AuthAdminInstrumentsNewLazyRoute: typeof AuthAdminInstrumentsNewLazyRoute
  AuthAdminIntegrationsItransplantLazyRoute: typeof AuthAdminIntegrationsItransplantLazyRoute
  AuthAdminMaterialsNewLazyRoute: typeof AuthAdminMaterialsNewLazyRoute
  AuthAdminPanelsNewLazyRoute: typeof AuthAdminPanelsNewLazyRoute
  AuthAdminPrintersNewLazyRoute: typeof AuthAdminPrintersNewLazyRoute
  AuthAdminProcessesNewLazyRoute: typeof AuthAdminProcessesNewLazyRoute
  AuthAdminResultsNewLazyRoute: typeof AuthAdminResultsNewLazyRoute
  AuthAdminTestsNewLazyRoute: typeof AuthAdminTestsNewLazyRoute
  AuthAdminTubesNewLazyRoute: typeof AuthAdminTubesNewLazyRoute
  AuthAdminWorkflowsNewLazyRoute: typeof AuthAdminWorkflowsNewLazyRoute
  AuthAdminInsightsIndexRoute: typeof AuthAdminInsightsIndexRoute
  AuthAdminAuditIndexLazyRoute: typeof AuthAdminAuditIndexLazyRoute
  AuthAdminAuthIndexLazyRoute: typeof AuthAdminAuthIndexLazyRoute
  AuthAdminBillingIndexLazyRoute: typeof AuthAdminBillingIndexLazyRoute
  AuthAdminClientsIndexLazyRoute: typeof AuthAdminClientsIndexLazyRoute
  AuthAdminInstrumentsIndexLazyRoute: typeof AuthAdminInstrumentsIndexLazyRoute
  AuthAdminIntegrationsIndexLazyRoute: typeof AuthAdminIntegrationsIndexLazyRoute
  AuthAdminMaterialsIndexLazyRoute: typeof AuthAdminMaterialsIndexLazyRoute
  AuthAdminPanelsIndexLazyRoute: typeof AuthAdminPanelsIndexLazyRoute
  AuthAdminPrintersIndexLazyRoute: typeof AuthAdminPrintersIndexLazyRoute
  AuthAdminProcessesIndexLazyRoute: typeof AuthAdminProcessesIndexLazyRoute
  AuthAdminResultsIndexLazyRoute: typeof AuthAdminResultsIndexLazyRoute
  AuthAdminSettingsIndexLazyRoute: typeof AuthAdminSettingsIndexLazyRoute
  AuthAdminTestsIndexLazyRoute: typeof AuthAdminTestsIndexLazyRoute
  AuthAdminTubesIndexLazyRoute: typeof AuthAdminTubesIndexLazyRoute
  AuthAdminUsersIndexLazyRoute: typeof AuthAdminUsersIndexLazyRoute
  AuthAdminWorkflowsIndexLazyRoute: typeof AuthAdminWorkflowsIndexLazyRoute
  AuthAdminBillingInvoicesIdRoute: typeof AuthAdminBillingInvoicesIdRoute
  AuthAdminBillingMasterInvoicesIdRoute: typeof AuthAdminBillingMasterInvoicesIdRoute
  AuthAdminBillingMasterInvoicesPreviewRoute: typeof AuthAdminBillingMasterInvoicesPreviewRoute
  AuthAdminClientsIdEditRoute: typeof AuthAdminClientsIdEditRoute
  AuthAdminInstrumentsIdEditRoute: typeof AuthAdminInstrumentsIdEditRoute
  AuthAdminMaterialsIdEditRoute: typeof AuthAdminMaterialsIdEditRoute
  AuthAdminPanelsIdEditRoute: typeof AuthAdminPanelsIdEditRoute
  AuthAdminPrintersIdEditRoute: typeof AuthAdminPrintersIdEditRoute
  AuthAdminResultsIdEditRoute: typeof AuthAdminResultsIdEditRoute
  AuthAdminTubesIdEditRoute: typeof AuthAdminTubesIdEditRoute
  AuthAdminUsersIdEditRoute: typeof AuthAdminUsersIdEditRoute
  AuthAdminWorkflowsIdEditRoute: typeof AuthAdminWorkflowsIdEditRoute
  AuthAdminAuthProvidersNewLazyRoute: typeof AuthAdminAuthProvidersNewLazyRoute
  AuthAdminTubesFieldSetsNewLazyRoute: typeof AuthAdminTubesFieldSetsNewLazyRoute
  AuthAdminTubesFieldsNewLazyRoute: typeof AuthAdminTubesFieldsNewLazyRoute
  AuthAdminProcessesIdIndexRoute: typeof AuthAdminProcessesIdIndexRoute
  AuthAdminAuthProvidersIdEditRoute: typeof AuthAdminAuthProvidersIdEditRoute
  AuthAdminBillingInvoicesPreviewOrgIdRoute: typeof AuthAdminBillingInvoicesPreviewOrgIdRoute
  AuthAdminProcessesIdVersionsVersionIdRoute: typeof AuthAdminProcessesIdVersionsVersionIdRoute
  AuthAdminTubesFieldSetsIdEditRoute: typeof AuthAdminTubesFieldSetsIdEditRoute
  AuthAdminTubesFieldsIdEditRoute: typeof AuthAdminTubesFieldsIdEditRoute
  AuthAdminTestsIdEditIndexRoute: typeof AuthAdminTestsIdEditIndexRoute
  AuthAdminTestsIdEditResultsSpecIdRoute: typeof AuthAdminTestsIdEditResultsSpecIdRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminClientsNewLazyRoute: AuthAdminClientsNewLazyRoute,
  AuthAdminInstrumentsNewLazyRoute: AuthAdminInstrumentsNewLazyRoute,
  AuthAdminIntegrationsItransplantLazyRoute:
    AuthAdminIntegrationsItransplantLazyRoute,
  AuthAdminMaterialsNewLazyRoute: AuthAdminMaterialsNewLazyRoute,
  AuthAdminPanelsNewLazyRoute: AuthAdminPanelsNewLazyRoute,
  AuthAdminPrintersNewLazyRoute: AuthAdminPrintersNewLazyRoute,
  AuthAdminProcessesNewLazyRoute: AuthAdminProcessesNewLazyRoute,
  AuthAdminResultsNewLazyRoute: AuthAdminResultsNewLazyRoute,
  AuthAdminTestsNewLazyRoute: AuthAdminTestsNewLazyRoute,
  AuthAdminTubesNewLazyRoute: AuthAdminTubesNewLazyRoute,
  AuthAdminWorkflowsNewLazyRoute: AuthAdminWorkflowsNewLazyRoute,
  AuthAdminInsightsIndexRoute: AuthAdminInsightsIndexRoute,
  AuthAdminAuditIndexLazyRoute: AuthAdminAuditIndexLazyRoute,
  AuthAdminAuthIndexLazyRoute: AuthAdminAuthIndexLazyRoute,
  AuthAdminBillingIndexLazyRoute: AuthAdminBillingIndexLazyRoute,
  AuthAdminClientsIndexLazyRoute: AuthAdminClientsIndexLazyRoute,
  AuthAdminInstrumentsIndexLazyRoute: AuthAdminInstrumentsIndexLazyRoute,
  AuthAdminIntegrationsIndexLazyRoute: AuthAdminIntegrationsIndexLazyRoute,
  AuthAdminMaterialsIndexLazyRoute: AuthAdminMaterialsIndexLazyRoute,
  AuthAdminPanelsIndexLazyRoute: AuthAdminPanelsIndexLazyRoute,
  AuthAdminPrintersIndexLazyRoute: AuthAdminPrintersIndexLazyRoute,
  AuthAdminProcessesIndexLazyRoute: AuthAdminProcessesIndexLazyRoute,
  AuthAdminResultsIndexLazyRoute: AuthAdminResultsIndexLazyRoute,
  AuthAdminSettingsIndexLazyRoute: AuthAdminSettingsIndexLazyRoute,
  AuthAdminTestsIndexLazyRoute: AuthAdminTestsIndexLazyRoute,
  AuthAdminTubesIndexLazyRoute: AuthAdminTubesIndexLazyRoute,
  AuthAdminUsersIndexLazyRoute: AuthAdminUsersIndexLazyRoute,
  AuthAdminWorkflowsIndexLazyRoute: AuthAdminWorkflowsIndexLazyRoute,
  AuthAdminBillingInvoicesIdRoute: AuthAdminBillingInvoicesIdRoute,
  AuthAdminBillingMasterInvoicesIdRoute: AuthAdminBillingMasterInvoicesIdRoute,
  AuthAdminBillingMasterInvoicesPreviewRoute:
    AuthAdminBillingMasterInvoicesPreviewRoute,
  AuthAdminClientsIdEditRoute: AuthAdminClientsIdEditRoute,
  AuthAdminInstrumentsIdEditRoute: AuthAdminInstrumentsIdEditRoute,
  AuthAdminMaterialsIdEditRoute: AuthAdminMaterialsIdEditRoute,
  AuthAdminPanelsIdEditRoute: AuthAdminPanelsIdEditRoute,
  AuthAdminPrintersIdEditRoute: AuthAdminPrintersIdEditRoute,
  AuthAdminResultsIdEditRoute: AuthAdminResultsIdEditRoute,
  AuthAdminTubesIdEditRoute: AuthAdminTubesIdEditRoute,
  AuthAdminUsersIdEditRoute: AuthAdminUsersIdEditRoute,
  AuthAdminWorkflowsIdEditRoute: AuthAdminWorkflowsIdEditRoute,
  AuthAdminAuthProvidersNewLazyRoute: AuthAdminAuthProvidersNewLazyRoute,
  AuthAdminTubesFieldSetsNewLazyRoute: AuthAdminTubesFieldSetsNewLazyRoute,
  AuthAdminTubesFieldsNewLazyRoute: AuthAdminTubesFieldsNewLazyRoute,
  AuthAdminProcessesIdIndexRoute: AuthAdminProcessesIdIndexRoute,
  AuthAdminAuthProvidersIdEditRoute: AuthAdminAuthProvidersIdEditRoute,
  AuthAdminBillingInvoicesPreviewOrgIdRoute:
    AuthAdminBillingInvoicesPreviewOrgIdRoute,
  AuthAdminProcessesIdVersionsVersionIdRoute:
    AuthAdminProcessesIdVersionsVersionIdRoute,
  AuthAdminTubesFieldSetsIdEditRoute: AuthAdminTubesFieldSetsIdEditRoute,
  AuthAdminTubesFieldsIdEditRoute: AuthAdminTubesFieldsIdEditRoute,
  AuthAdminTestsIdEditIndexRoute: AuthAdminTestsIdEditIndexRoute,
  AuthAdminTestsIdEditResultsSpecIdRoute:
    AuthAdminTestsIdEditResultsSpecIdRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthAppRouteRoute: typeof AuthAppRouteRouteWithChildren
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppRouteRoute: AuthAppRouteRouteWithChildren,
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  CompleteProfileRoute: CompleteProfileRoute,
  ErrorRoute: ErrorRoute,
  HealthRoute: HealthRoute,
  LoginRoute: LoginRoute,
  LoginActionRoute: LoginActionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
